<vng-dialog-content class="advanced-search-dialog-content">
  <div class="search-row">
    <vng-input label="FlyCut :" placeholder="FlyCut :" type="text" style="flex:1 1 0%" class="dis_ex"
      [formControl]="form.controls['flycut']" (input)="keyDownFunction($event)"></vng-input>
  </div>
  <div class="search-row">
    <vng-input label="Title :" placeholder="Title :" type="text" style="flex:1 1 0%" class="dis_ex"
      [formControl]="form.controls['title']" (input)="keyDownFunction($event)"></vng-input>
  </div>
  <div class="search-row">
    <vng-input label="Has the words :" placeholder="Has the words :" type="text" style="flex:1 1 0%" class="dis_ex"
      [formControl]="form.controls['hasTheWords']" (input)="keyDownFunction($event)"></vng-input>
  </div>
  <div class="search-row">
    <vng-input label="Doesn’t have :" placeholder="Doesn’t have :" type="text" style="flex:1 1 0%" class="dis_ex"
      [formControl]="form.controls['doesntHave']" (input)="keyDownFunction($event)"></vng-input>
  </div>
  <div class="search-row search-row--gap">
    <vng-select label="Created within :" placeholder="Created within :" style="flex:1 1 0%"
      [formControl]="form.controls['createdWithin']" [options]="createdWithinOptions"
      (selectionChange)="advancedSearch('createdWithin')"></vng-select>
    <!-- R16: mat-datepicker + MomentDateAdapter → vng-datepicker. Emits/accepts
         MM/DD/YYYY strings (also accepts a Date, e.g. the new Date() written
         above by advancedSearch()) — getDate() converts via `new Date(raw)`. -->
    <!-- P2: the datepicker needs the same `label` as the select next to it —
         without one its box started ~20px higher than the "Created within :"
         field. It also gives the control an accessible name. -->
    <!-- V3-12: vng-datepicker wraps a native <input type="date">, so Chrome draws
         its own "mm/dd/yyyy" format hint and its monochrome calendar indicator —
         the only un-branded control in the dialog. `date-empty` lets the CSS hide
         the format hint while the field is empty and unfocused (master's
         mat-datepicker showed nothing), and the indicator is repainted in the
         brand orange there too. -->
    <vng-datepicker label="Date :" style="flex:1 1 0%" class="dis_ex" [class.date-empty]="!form.controls['date'].value"
      [formControl]="form.controls['date']" (dateChange)="advancedSearch('store')">
    </vng-datepicker>
  </div>
  <div class="search-row">
    <!-- 04 §3.4 / 03 R5: mat-optgroup composition — disabled header options
         (unselectable + keyboard-skipped for free) + a #vngSelectOption
         template distinguishing header rows from real items; portal CSS in
         src/assets/styles/app.scss. Non-searchable, matching today. -->
    <vng-select label="Search :" placeholder="Search :" style="flex:1 1 0%" [formControl]="form.controls['bySearch']"
      [options]="bySearchOptions" (selectionChange)="advancedSearch('store')">
      <ng-template #vngSelectOption let-opt>
        <span *ngIf="opt.data?.header" class="opt-group-hdr">{{ opt.label }}</span>
        <span *ngIf="!opt.data?.header" class="opt-group-item">{{ opt.label }}</span>
      </ng-template>
    </vng-select>
  </div>
  <div class="search-row search-row--gap">
    <section style="flex:1 1 0%">
      <vng-checkbox [formControl]="form.controls['hasAttachment']" (change)="advancedSearch('store')">Has
        Attachment</vng-checkbox>
    </section>
    <section style="flex:1 1 0%">
      <vng-checkbox [formControl]="form.controls['hasHyperlink']" (change)="advancedSearch('store')">Has
        Hyperlink</vng-checkbox>
    </section>
  </div>
</vng-dialog-content>
<vng-dialog-actions align="end">
  <!-- P1: dismiss buttons use `outline` (light border), not `secondary`
       (near-black border). -->
  <button vng-button variant="outline" size="md" (click)="closeDialog()">Cancel</button>
  <button vng-button variant="primary" size="md" [vngDialogClose]="true" (click)="advancedSearch('search')">
    Search
  </button>
</vng-dialog-actions>